import React from "react";
import { Button } from "reactstrap";
import { downloadFile, getFilenameFromUrl } from "./utils";

const MediaViewer = ({ isOpen, onClose, viewerUrl, viewerType, videoPlayingRef }) => {
  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1050,
        background: 'rgba(0, 0, 0, 0.89)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px'
      }}
    >
      {/* Controls */}
      <div style={{ position: 'fixed', top: 12, right: 16, display: 'flex', gap: 8 }}>
        <Button color="light" size="sm" onClick={(e) => { e.stopPropagation(); downloadFile(viewerUrl, getFilenameFromUrl(viewerUrl)); }} title="Download">
          <i className="ri-download-2-line"></i>
        </Button>
        <Button color="light" size="sm" onClick={(e) => { e.stopPropagation(); onClose(); }} title="Close">
          <i className="ri-close-line"></i>
        </Button>
      </div>
      <div onClick={(e) => e.stopPropagation()} style={{ maxWidth: '95%', maxHeight: '90vh' }}>
        {viewerType === 'image' && (
          <img src={viewerUrl} alt="preview" style={{ display: 'block', maxWidth: '100%', maxHeight: '90vh', height: 'auto' }} />
        )}
        {viewerType === 'video' && (
          <>
            <video 
              key={`viewer-video-${viewerUrl}`}
              src={viewerUrl} 
              controls 
              preload="auto"
              playsInline
              onPlay={(e) => {
                e.stopPropagation();
                videoPlayingRef.current.add(`viewer-${viewerUrl}`);
              }}
              onPause={(e) => {
                e.stopPropagation();
                videoPlayingRef.current.delete(`viewer-${viewerUrl}`);
              }}
              onEnded={(e) => {
                e.stopPropagation();
                videoPlayingRef.current.delete(`viewer-${viewerUrl}`);
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                const errorMsg = e.target.parentElement.querySelector('.viewer-error');
                if (errorMsg) errorMsg.style.display = 'block';
                videoPlayingRef.current.delete(`viewer-${viewerUrl}`);
              }}
              onLoadStart={(e) => {
                e.stopPropagation();
              }}
              style={{ display: 'block', maxWidth: '100%', maxHeight: '90vh' }} 
            />
            <div className="viewer-error" style={{ display: 'none', padding: '20px', textAlign: 'center', color: '#6c757d' }}>
              <i className="ri-video-line" style={{ fontSize: '48px', marginBottom: '10px' }}></i>
              <p>Video cannot be loaded</p>
            </div>
          </>
        )}
        {viewerType === 'audio' && (
          <audio src={viewerUrl} controls style={{ width: '100%' }} />
        )}
        {viewerType === 'pdf' && (
          <iframe title="pdf" src={viewerUrl} style={{ width: '80vw', height: '85vh', border: '1px solid #ddd', background: '#fff', borderRadius: 8 }} />
        )}
      </div>
    </div>
  );
};

export default MediaViewer;

